/**
 * Convert a camera name to a URL-friendly slug
 * @param {string} name - Camera name
 * @returns {string} URL-friendly slug
 */
export function nameToSlug(name) {
  return name
    .toLowerCase()
    .trim()
    // Replace spaces and special characters with hyphens
    .replace(/[^\w\s-]/g, '') // Remove special characters except word chars, spaces, and hyphens
    .replace(/[\s_]+/g, '-')   // Replace spaces and underscores with hyphens
    .replace(/-+/g, '-')       // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
}

/**
 * Find a camera by its slug
 * @param {Array} cameras - Array of camera objects
 * @param {string} slug - URL slug
 * @returns {Object|null} Camera object or null if not found
 */
export function findCameraBySlug(cameras, slug) {
  return cameras.find(cam => nameToSlug(cam.name) === slug) || null;
}

